
// 导出配置
export default {
  // 登录URL - 直接使用环境变量
  loginUrl: process.env.VUE_APP_LOGIN_URL || 'https://172.31.26.202:20082/web/#',
  
  // 其他配置项可以在这里添加
  apiBaseUrl: process.env.API_BASE_URL 
}; 